import * as Sentry from '@sentry/react';

// Sentry configuration
export const initSentry = () => {
  // Skip Sentry initialization in development to avoid errors
  if (import.meta.env.DEV) {
    console.log('Sentry initialization skipped in development');
    return;
  }

  // Skip if no DSN is configured
  const dsn = "YOUR_SENTRY_DSN_HERE";
  if (!dsn || dsn === "YOUR_SENTRY_DSN_HERE") {
    console.log('Sentry initialization skipped - no DSN configured');
    return;
  }

  Sentry.init({
    dsn: dsn,
    environment: import.meta.env.MODE,
    
    // Performance monitoring
    tracesSampleRate: 0.1,
    
    // Release tracking  
    release: `business-crm@1.0.0`,
    
    // Additional context
    initialScope: {
      tags: {
        component: 'frontend',
        feature: 'business-crm'
      }
    }
  });
};

// Custom Sentry utilities
export const captureBusinessEvent = (
  event: string, 
  data: Record<string, any>, 
  level: Sentry.SeverityLevel = 'info'
) => {
  Sentry.addBreadcrumb({
    message: event,
    data,
    level,
    category: 'business-action'
  });
  
  Sentry.captureMessage(event, level);
};

export const setUserContext = (user: { id: string; email?: string; role?: string }) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    role: user.role
  });
};

export const clearUserContext = () => {
  Sentry.setUser(null);
};

// Error boundary wrapper
export const SentryErrorBoundary = Sentry.withErrorBoundary;